import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from 'src/app/shared/services/api/api-base/api-base.service';
import { ScorePositionEnum } from '../common/globalEnums.enums';
@Injectable()
export class ValuesGamePlayerCoreService {
  constructor(private _api: ApiBaseService) {}

  public getValuesPlayerLeaderboard(
    divisionId: string,
    valuesGameId: string,
    maxRank = 10000,
    scorePosition = 'last' as const,
  ): Observable<IValuesGamePlayerRank[]> {
    const query: IValuesGamePlayerLeaderboardQuery = {
      maxRank: maxRank || 10000,
      divisionId,
      valuesGameId,
      scorePosition,
    };

    return this._api.get(`values-game-player/leaderboard`, query);
  }
}

export interface IValuesGamePlayerRank {
  _id: string;
  learnerId: string;
  divisionId: string;
  firstName: string;
  lastName: string;
  highestScore: number;
  email: string;
  rank: number;
  extraDetail: any;
  updatedAt: Date | string;
  completedAt: Date | string;
  loginCount: number;
  scores: [];
  totolScore: number;
  valueScores: {
    [name: string]: string;
  };
}

export interface IValuesGamePlayerLeaderboardQuery {
  limit?: number;
  skip?: number;
  search?: string;
  divisionId?: string;
  maxRank?: number;
  valuesGameId: string;
  scorePosition?: ScorePositionEnum;
}
